import { render, staticRenderFns } from "./edit-ad-form.vue?vue&type=template&id=3596452d&scoped=true&"
import script from "./edit-ad-form.vue?vue&type=script&lang=js&"
export * from "./edit-ad-form.vue?vue&type=script&lang=js&"
import style0 from "./edit-ad-form.vue?vue&type=style&index=0&id=3596452d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3596452d",
  null
  
)

export default component.exports